__turbopack_context__.v({
  "destructive": "Button-module__Qfjjaq__destructive",
  "discount": "Button-module__Qfjjaq__discount",
  "main": "Button-module__Qfjjaq__main",
  "primary": "Button-module__Qfjjaq__primary",
  "pulse": "Button-module__Qfjjaq__pulse",
  "pulseAnimation": "Button-module__Qfjjaq__pulseAnimation",
  "secondary": "Button-module__Qfjjaq__secondary",
  "suggested": "Button-module__Qfjjaq__suggested",
});
